import {Component, forwardRef, Input, EventEmitter, Output} from '@angular/core';
import {
	NG_VALUE_ACCESSOR,
	NG_VALIDATORS,
	ControlValueAccessor,
	Validator,
	AbstractControl,
	Validators,
	FormControl
} from '@angular/forms';
import {UIFormEngineComponentMetadata} from './form';
import {CVA} from './cva';


@Component({
	selector: 'ui-input-datepicker',
	//host: {'(blur)': 'onTouched($event)'},
	template: `
		<div class="ui-input-presentation" *ngIf="presentationMode">
			{{cva.value}}
		</div>

		<ng-container *ngIf="!presentationMode">
			<div class="input-group ui-input-datepicker">
				<input
					readonly
					class="readonly form-control"
					(dateChange)="onDateChanged($event)"
					[(ngModel)]="cva.value"
					name="{{name}}"
					(click)="myDatepicker.open()"
					matInput
					[matDatepicker]="myDatepicker"
				>
				<div class="input-group-append" *ngIf="!cva.value">
					<i class="material-icons">
						calendar_today
					</i>
				</div>
				<div class="input-group-append ui-input-datepicker-closer" *ngIf="cva.value"
					 (click)="writeValueFromInput(null);$event.preventDefault()" style="z-index:1000">
					<i class="material-icons">close</i>
				</div>
				<mat-datepicker #myDatepicker></mat-datepicker>
			</div>
		</ng-container>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputDatePickerComponent),
			multi: true
		}
	]
})
export class UIInputDatePickerComponent extends CVA {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() presentationMode = false;

	onDateChanged(d) {
		console.log('onDateChanged', d.value);
		let innerValue = d.value._isAMomentObject ?
			d.value.format('YYYY-MM-DD')
			: d.value.getUTCFullYear() + '-' + (d.value.getMonth() + 1 < 10 ? '0' : '') + (d.value.getMonth() + 1) + '-' + (d.value.getDate() < 10 ? '0' : '') + d.value.getDate();
		this.writeValueFromInput(innerValue);
	}

	/* dateChange(d) {
		 console.log('datechange', d.value);
		 this.innerValue = d.value._isAMomentObject ? d.value.format('YYYY-MM-DD') : d.value.getUTCFullYear() + '-' + (d.value.getMonth() + 1 < 10 ? '0' : '') + (d.value.getMonth() + 1) + '-' + (d.value.getDate() < 10 ? '0' : '') + d.value.getDate();
		 this.writeValue(this.innerValue);
		 console.log('datechange this.innerValue', this.innerValue, d.value.format('YYYY-MM-DD'));
	  //   this.onChangeCallback(this.innerValue);
	 }*/

	//set accessor including call the onchange callback
	/*set value(v: any) {
		if (v != this.innerValue) {
			if (v) {
				const re = /([0-9]{4})-([0-9]{2})-([0-9]{2})/;
				if (re.test(v)) {
					const m = v.match(re);
					this.innerValue = v;
					this.innerDate = new Date(m[1], parseInt(m[2]) - 1, m[3]);
					this.onChangeCallback(this.innerValue);
				}
			}
		}
	}*/
}
